/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldEditor} from "./BaseFieldEditor";
import {service as TaxLotService} from "../../../Services/TaxLotService";
import autobind from "autobind-decorator";
import Autocomplete from "react-autocomplete";
import {StreamBankAutoCompleteItem} from "../../../Components/Common/StreamBankAutoCompleteItem";
import React from "react";

export class TaxLotFieldEditor extends BaseFieldEditor {
	constructor(props) {
		super(props)

		this.setInitialState({
			taxLots: [],
			value: "",
			values: []
		});
	}

	componentDidMount() {
		TaxLotService.Get()
			.then((x) => {
				let value = "";

				if (this.props.Value) {
					let taxLot = x.result.find((x) => Number(x.taxLotId) === Number(this.props.Value));

					if (taxLot) {
						value = taxLot.parcelNumber;
					}
				}

				this.setState({
					taxLots: x.result,
					value: value
				}, () => {
					//filter on hucCode and name. Then take the first 20
					let values = this.state.taxLots.filter((x) =>
						(
							x.parcelNumber.toLowerCase().includes(this.state.value.toLowerCase())
						)
					).slice(0, 20);

					this.setState({values: values});
				});
			});
	}

	@autobind
	_render() {
		return <div className="autocomplete-column">
			<Autocomplete
				value={this.state.value}
				inputProps={{className: 'autocomplete-input', placeholder: "Tax Lot"}}
				wrapperStyle={{position: 'relative', display: 'inline-block'}}
				items={this.state.values}
				getItemValue={(item) => item.taxLotId}
				onChange={(event, value) => {
					this.setState({value: value}, () => {
						//filter on hucCode and name. Then take the first 20
						let values = this.state.taxLots.filter((x) =>
							(
								x.parcelNumber.toLowerCase().includes(value.toLowerCase())
							)
						).slice(0, 20);

						this.setState({values: values});
					});
				}}
				onSelect={(value, item) => {
					this.setState({value: item.parcelNumber}, () => {
						this.props.OnUpdate(item.taxLotId)
					});
				}}
				renderMenu={children => (
					<div className="sb-autocomplete-menu sb-autocomplete-menu-taxLot">
						{children}
					</div>
				)}
				renderItem={(item, isHighlighted) => (
					<StreamBankAutoCompleteItem
						className="sb-autocomplete-item-taxLot"
						key={item.taxLotId}
						isHighlighted={isHighlighted}
						title={item.parcelNumber}
					/>
				)}
			/>
		</div>;
	}
}